import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68dfb604"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = { class: "q-pa-md" }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","margin-bottom":"15px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Referat", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Id", -1))
const _hoisted_11 = { class: "col-8 form__label__black" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Scop / Titlu achizitie", -1))
const _hoisted_14 = { class: "col-8 form__label__black" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Motivare descriere detaliata", -1))
const _hoisted_17 = { class: "col-8 form__label__black" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Stare", -1))
const _hoisted_20 = { class: "col-8 form__label__black" }
const _hoisted_21 = {
  clas: "row",
  style: {"margin-top":"15px"}
}
const _hoisted_22 = { class: "q-pa-xs" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Servicii / Articole necesare", -1))
const _hoisted_24 = {
  key: 0,
  clas: "row",
  style: {"margin-top":"5px","margin-bottom":"15px"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = {
  class: "absolute-bottom-right q-pa-sm",
  style: {"margin-top":"15px","margin-right":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_TaskList = _resolveComponent("TaskList")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_form, { ref: "myForm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  })
                      }, _hoisted_8, 2)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.referat.id_referat), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.referat.denumire), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.referat.descriere), 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.getDenStatus(_ctx.referat.stare as string)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_q_table, {
                        dense: "",
                        "rows-per-page-options": [0],
                        rows: _ctx.tableDataReferateServicii,
                        columns: _ctx.columns,
                        "visible-columns": _ctx.visibleColumns,
                        "row-key": "appid",
                        filter: _ctx.filterReferateServicii,
                        loading: _ctx.loadingData,
                        pagination: _ctx.myPagination
                      }, {
                        top: _withCtx(() => [
                          _hoisted_23,
                          _createVNode(_component_q_space),
                          _createVNode(_component_q_input, {
                            dense: "",
                            debounce: "300",
                            color: "primary",
                            modelValue: _ctx.filterReferateServicii,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterReferateServicii) = $event))
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_q_icon, { name: "search" })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        body: _withCtx((props) => [
                          _createVNode(_component_q_tr, { props: props }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_td, {
                                key: "id_referat_servici",
                                props: props
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.row.id_referat_servici), 1)
                                ]),
                                _: 2
                              }, 1032, ["props"]),
                              _createVNode(_component_q_td, {
                                key: "id_tip",
                                props: props,
                                sortable: true
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.tipDenumire(props.row.id_tip)), 1)
                                ]),
                                _: 2
                              }, 1032, ["props"]),
                              _createVNode(_component_q_td, {
                                key: "denumire",
                                props: props,
                                sortable: true,
                                style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.row.denumire), 1)
                                ]),
                                _: 2
                              }, 1032, ["props"]),
                              _createVNode(_component_q_td, {
                                key: "valoare",
                                props: props,
                                sortable: true
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(props.row.valoare) + " RON ", 1)
                                ]),
                                _: 2
                              }, 1032, ["props"])
                            ]),
                            _: 2
                          }, 1032, ["props"])
                        ]),
                        _: 1
                      }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"])
                    ])
                  ]),
                  (_ctx.referat.stare !== 'initiat')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_component_TaskList, {
                          appid: _ctx.appid,
                          task: _ctx.task,
                          onState: _ctx.onState,
                          isSuccess: _ctx.isSuccess
                        }, null, 8, ["appid", "task", "onState", "isSuccess"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.referat.appid !== 0)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        label: "DESCARCA REFERAT",
                        color: "brown",
                        size: "sm",
                        onClick: _ctx.onDownload,
                        style: {"margin-left":"5px"}
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_btn, {
                    label: "Renunt",
                    type: "reset",
                    size: "sm",
                    flat: "",
                    onClick: _ctx.onCancel,
                    style: {"margin-left":"5px"}
                  }, null, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          }, 512)
        ]))
  ]))
}